export default __webpack_public_path__ + "static/media/nodejs.25b3b685.png";